import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '⚡',
  title: 'Freedom From Planning Stress',
  description: 'Open the system. Choose the volume. Run the session. The planning is already done.'
}, {
  emoji: '👑',
  title: 'Authority And Confidence',
  description: 'With a proven structure behind you, you arrive at training knowing exactly what to do and how to do it.'
}, {
  emoji: '📈',
  title: 'Real Player Development',
  description: 'Structured progressions help your players improve faster and more consistently throughout the season.'
}, {
  emoji: '😌',
  title: 'No More Session Panic',
  description: 'Stop wondering what to run tomorrow. Football Ready gives you a complete roadmap for the entire year.'
}];
export function Benefits() {
  return <section className="py-20 bg-navy-950 relative" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-3">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-4">
            WHAT WILL CHANGE?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 font-medium" data-id="element-5">
            What will change in your coaching life?
            <br data-id="element-6" />
            Real benefits from the very first week.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-7">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex gap-6 items-start" data-id="element-8">
              <div className="flex-shrink-0 w-16 h-16 bg-navy-900 border border-navy-700 rounded-2xl flex items-center justify-center text-3xl shadow-lg" data-id="element-9">
                {benefit.emoji}
              </div>
              <div data-id="element-10">
                <h3 className="font-oswald text-2xl text-white uppercase tracking-wide mb-2" data-id="element-11">
                  {benefit.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-12">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}